
import { Component, Vue } from 'nuxt-property-decorator'

@Component({
  // @ts-ignore
  amp: 'hybrid',
  ampLayout: 'amp'
})
export default class extends Vue {
  head () {
    return {
      title: this.$t('head.title.about'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('head.description.about') },
        { hid: 'og:title', name: 'og:title', content: this.$t('head.title.about') },
        { hid: 'og:description', name: 'og:description', content: this.$t('head.description.about') },
        { hid: 'og:image', name: 'og:image', content: require('~/assets/img/logo-black.svg') },
        { hid: 'og:type', name: 'og:type', content: 'website' },
        { hid: 'og:url', name: 'og:url', content: process.env.API_ENDPOINT + this.$route.fullPath }
      ]
    }
  }
}
